import { useSyncExternalStore } from 'react'

/** Last catalog command whose spinner ended on timeout. Mode is left unchanged. */

export const CATALOG_NO_CONFIRMATION_TITLE = 'No confirmation'

type CatalogOperationTimeoutNotice = {
  robotId: number
  actionKey: string
  modeAtTimeout: number | null
}

let notice: CatalogOperationTimeoutNotice | null = null
const listeners = new Set<() => void>()

function emit() {
  listeners.forEach(listener => listener())
}

export function setCatalogOperationTimeoutNotice(
  robotId: number,
  actionKey: string,
  modeAtTimeout: number | null
) {
  notice = { robotId, actionKey, modeAtTimeout }
  emit()
}

export function clearCatalogOperationTimeoutNotice() {
  if (!notice) {
    return
  }
  notice = null
  emit()
}

export function readCatalogOperationTimeoutNotice(): CatalogOperationTimeoutNotice | null {
  return notice
}

export function subscribeCatalogOperationTimeoutNotice(onStoreChange: () => void) {
  listeners.add(onStoreChange)
  return () => {
    listeners.delete(onStoreChange)
  }
}

export function useCatalogOperationTimeoutActionKey(robotId: number | undefined): string | null {
  const current = useSyncExternalStore(
    subscribeCatalogOperationTimeoutNotice,
    readCatalogOperationTimeoutNotice,
    () => null
  )
  if (!current || current.robotId !== robotId) {
    return null
  }
  return current.actionKey
}
